import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fn-custom-carousal',
  templateUrl: './fn-custom-carousal.component.html',
  styleUrls: ['./fn-custom-carousal.component.scss']
})
export class FnCustomCarousalComponent implements OnInit {

  /*******
   * Array format = [Array[{}.{}]Arrray[{},{}]]
   * *******/
  @Input() showIconMapped: Array<any> = [];
  IndexIc = 0;

  constructor() { }

  ngOnInit() {
  }

  // Move to previous slide
  getToPrev() {
    if (this.IndexIc > 0) {
      this.IndexIc--;
    }
  }

  // Move to next slide
  goToNext() {
    if (this.showIconMapped && this.showIconMapped.length > 0) {
      if (this.IndexIc < this.showIconMapped.length - 1) {
        this.IndexIc++;
      }
    }
  }
  changePageRender(index: number) {
    this.IndexIc = index;
  }

}
